export default __webpack_public_path__ + "static/media/ic_event_note_48px.8f99eafd.svg";